module.exports = __webpack_public_path__ + "fonts/623e320.woff";